(function () {
  // Le champ photo de la fiche kit personnalise est pose par Uploadery, dont le script rend 401 depuis
  // fin juillet : plus rien ne remonte le fichier, le clic d'ajout au panier est avale et aucune requete
  // /cart/add ne part. Shopify sait pourtant heberger un fichier en propriete de ligne, nativement, si
  // le formulaire part en multipart et sans AJAX. On reprend donc la main : le champ visible reste ou il
  // est (son texte d'aide aussi), on recopie le fichier dans le formulaire qui porte la variante, et on
  // soumet nativement. Aucune app, aucun abonnement.
  //
  // L'app d'options redessine le bouton apres coup : on n'accroche donc rien au bouton lui-meme, tout
  // est resolu au moment du clic, sur un seul ecouteur pose sur le document.
  var PROP = "properties[Your photo]";

  /* Textes par langue de la vitrine. Langue lue sur Shopify.locale, puis <html lang>,
     et anglais par defaut. */
  var TXT = {"en":{"chooseFirst":"Choose the photo you'd like painted before adding to cart."},"fr":{"chooseFirst":"Choisissez la photo que vous souhaitez faire peindre avant de l'ajouter au panier."},"de":{"chooseFirst":"Wähle das Foto aus, das gemalt werden soll, bevor du es in den Warenkorb legst."},"es":{"chooseFirst":"Elige la foto que quieras que pintemos antes de añadir al carrito."},"it":{"chooseFirst":"Scegli la foto che vuoi far dipingere prima di aggiungere al carrello."},"ja":{"chooseFirst":"カートに追加する前に、描いてほしい写真を選択してください。"},"ko":{"chooseFirst":"장바구니에 담기 전에 그려드릴 사진을 선택해 주세요."},"lt":{"chooseFirst":"Prieš pridėdami į krepšelį, pasirinkite nuotrauką, kurią norite, kad nutapytume."},"nb":{"chooseFirst":"Velg bildet du vil ha malt, før du legger i handlekurven."},"pl":{"chooseFirst":"Wybierz zdjęcie, które chcesz mieć namalowane, zanim dodasz do koszyka."},"sv":{"chooseFirst":"Välj fotot du vill ha målat innan du lägger i varukorgen."},"zh-TW":{"chooseFirst":"加入購物車前，請先選擇您想要繪製的照片。"}};
  function langue() {
    var l = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en';
    if (TXT[l]) return l;
    var bas = String(l).toLowerCase();
    for (var k in TXT) if (k.toLowerCase() === bas) return k;
    if (/^zh/.test(bas)) return 'zh-TW';
    bas = bas.split('-')[0];
    return TXT[bas] ? bas : 'en';
  }
  function t(cle, v) {
    var s = (TXT[langue()] || {})[cle] || TXT.en[cle] || '';
    return s.replace(/\{(\w+)\}/g, function (m, n) { return v && v[n] != null ? v[n] : m; });
  }
  /* Le libelle du bouton change avec la langue : on le reconnait d'abord a sa place. */
  var ACHAT = '[name="add"], #abn-msticky-btn, #sticky-bar-button, .shopify-payment-button__button';
  function estAchat(b) {
    if (!b || !b.matches) return false;
    if (b.matches(ACHAT)) return true;
    if (b.type === 'submit' && b.closest('form[action*="/cart/add"]')) return true;
    var s = (b.innerText || b.value || '') + ' ' + (b.getAttribute('aria-label') || '');
    return /add to cart|buy it now|add to bag|ajouter au panier/i.test(s);
  }

  function boutonDepuis(cible) {
    var e = cible;
    while (e && e !== document) {
      if (e.tagName === "BUTTON" || (e.tagName === "INPUT" && e.type === "submit")) {
        // Le paiement express garde son propre parcours, comme avant.
        return estAchat(e) && !e.closest(".shopify-payment-button") ? e : null;
      }
      e = e.parentElement;
    }
    return null;
  }

  function champPhoto(form) {
    // Dans le formulaire d achat d abord, et sous le nom que Shopify attend : le champ de
    // l app (properties[Upload a File:]) vit dans un AUTRE formulaire, sans bouton d ajout.
    var portee = form || document;
    var direct = portee.querySelector('input[type="file"][name="' + PROP + '"]:not([data-abn-miroir])');
    if (direct) return direct;
    var c = portee.querySelectorAll('input[type="file"][name^="properties["]');
    for (var i = 0; i < c.length; i++) if (!c[i].hasAttribute("data-abn-miroir")) return c[i];
    return form ? champPhoto(null) : null;
  }

  function miroir(form) {
    var m = form.querySelector("input[data-abn-miroir]");
    if (!m) {
      m = document.createElement("input");
      m.type = "file";
      m.name = PROP;
      m.setAttribute("data-abn-miroir", "1");
      m.style.display = "none";
      form.appendChild(m);
    }
    return m;
  }

  function alerte(champ, texte) {
    var e = document.getElementById("abn-photo-alerte");
    if (!e) {
      e = document.createElement("p");
      e.id = "abn-photo-alerte";
      e.setAttribute("role", "alert");
      e.style.cssText = "color:#b42318;font-size:.875rem;margin:.5rem 0 0";
      (champ.parentElement || document.body).appendChild(e);
    }
    e.textContent = texte;
  }

  document.addEventListener("click", function (ev) {
    var bouton = boutonDepuis(ev.target);
    if (!bouton) return;
    var form = bouton.closest('form[action*="/cart/add"]');
    if (!form) return;
    var champ = champPhoto(form);
    if (!champ) return; // fiche sans photo : on ne touche a rien

    ev.preventDefault();
    ev.stopImmediatePropagation(); // sinon le gestionnaire de l'app avale la soumission

    if (!champ.files || !champ.files.length) {
      alerte(champ, t('chooseFirst'));
      champ.scrollIntoView({ block: "center", behavior: "smooth" });
      return;
    }
    // Photo trop petite : abn-photo-check.js demande un second clic avant de laisser partir la commande.
    if (window.abnGardePhoto && window.abnGardePhoto(ev)) return;
    champ.required = false; // la validation est la notre : le champ vit dans un autre formulaire
    form.setAttribute("enctype", "multipart/form-data");
    // Champ deja dans le bon formulaire sous le bon nom : rien a recopier.
    if (!(champ.form === form && champ.name === PROP)) miroir(form).files = champ.files;
    HTMLFormElement.prototype.submit.call(form); // natif : Shopify heberge le fichier
  }, true);
})();
